// CoinDetails.js
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

// Theme-aligned color constants
const CHART_LINE_COLOR = '#00D4FF';       // --electric-blue / --secondary
const CHART_GRID_COLOR = 'rgba(255,255,255,0.06)'; // --border-subtle
const CHART_TICK_COLOR = '#94A3B8';       // --text-secondary

function CoinDetails({ coin, history }) {
      // Prepare the data for the line chart
      const chartData = history.map((dataPoint) => ({
            date: new Date(dataPoint[0]).toLocaleDateString(),
            price: dataPoint[1],
      }));

      // Use CSS variables for semantic colors — keeps theme consistent
      const priceChangeColor = coin.price_change_24h < 0 ? 'var(--danger)' : 'var(--success)';

      return (
            <div className="coin-details">
                  <h2>
                        {coin.name} ({coin.symbol.toUpperCase()})
                  </h2>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', gap: '0.25rem' }}>
                        <span style={{ color: priceChangeColor, fontSize: '0.95rem', fontWeight: 600 }}>
                              {coin.price_change_24h > 0 && '+'}
                              {coin.price_change_24h?.toFixed(2)}%
                        </span>
                        <p style={{ fontSize: '1.75rem', fontWeight: 700, margin: 0, color: 'var(--text-primary)' }}>
                              ${coin.current_price?.toFixed(2)}
                        </p>
                        <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                              Current Price
                        </span>
                  </div>
                  <h3 style={{ marginTop: '1.25rem', color: 'var(--text-primary)' }}>Historical Data</h3>
                  <ResponsiveContainer width="100%" height={280}>
                        <LineChart data={chartData} margin={{ top: 5, right: 16, left: 0, bottom: 5 }}>
                              <CartesianGrid strokeDasharray="3 3" stroke={CHART_GRID_COLOR} />
                              <XAxis
                                    dataKey="date"
                                    tick={{ fontSize: 12, fill: CHART_TICK_COLOR }}
                                    tickLine={{ stroke: CHART_GRID_COLOR }}
                                    axisLine={{ stroke: CHART_GRID_COLOR }}
                              />
                              <YAxis
                                    tick={{ fontSize: 12, fill: CHART_TICK_COLOR }}
                                    tickLine={{ stroke: CHART_GRID_COLOR }}
                                    axisLine={{ stroke: CHART_GRID_COLOR }}
                                    tickFormatter={(v) => `$${v.toLocaleString()}`}
                              />
                              <Tooltip
                                    contentStyle={{
                                          background: 'var(--primary-light)',
                                          border: '1px solid var(--border-default)',
                                          borderRadius: 8,
                                          color: 'var(--text-primary)',
                                    }}
                                    labelStyle={{ color: 'var(--text-secondary)' }}
                                    formatter={(v) => [`$${v.toFixed(2)}`, 'Price']}
                              />
                              <Legend wrapperStyle={{ color: CHART_TICK_COLOR, fontSize: '0.85rem' }} />
                              <Line
                                    type="monotone"
                                    dataKey="price"
                                    stroke={CHART_LINE_COLOR}
                                    strokeWidth={2}
                                    dot={false}
                                    activeDot={{ r: 5, fill: CHART_LINE_COLOR }}
                              />
                        </LineChart>
                  </ResponsiveContainer>
            </div>
      );
}

export default CoinDetails;


